import { SET_FAVORITE_PLANT } from '../actions'

const INITIAL_STATE = {
    favorites: {},
}

function FavoritePlantsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_FAVORITE_PLANT:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    [action.payload]: !(state.favorites[action.payload] || false),
                },
            }
        default: return state
    }
}

export default FavoritePlantsReducer



// WEBPACK FOOTER //
// ./src/reducers/favoritePlants.js